import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RightArrowIcon = (props: IconProps) => (
  <Icon width="21px" height="21px" viewBox="0 0 21 21" {...props}>
    <path d="M5.81 3.996 12.814 11 5.81 18.005l1.884 1.884L16.584 11l-8.89-8.889L5.81 3.996Z" />
  </Icon>
);

export default memo(RightArrowIcon);
